export default __webpack_public_path__ + "static/awarepath_cover-big_1-e17f50fa76212dcf07cdce4cfa66794a.png";